export class CmsLoginDealsProperties {
    sr : Number = 0;
    dealTitle: string = "";
    dealImage: string = "";
    startDate: Date = new Date();
    expireDate: Date = new Date();
}

export class GroupTicketShowRightCMS {
    showGroupTicket:boolean=false;
}
